import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { trackCtaClick } from "../../constants/site";

const styles = {
    burgundy:
        "bg-burgundy text-cream shadow-burgundy/25 hover:bg-plum",
    gold: "bg-gradient-to-r from-goldlight to-gold text-white shadow-gold/30 hover:from-gold hover:to-[#A07733]",
};

export const CtaButton = ({ children, testId, className = "", variant = "burgundy", arrow = true }) => (
    <motion.a
        data-testid={testId}
        onClick={(e) => {
            trackCtaClick(testId);
            e.preventDefault();
            window.dispatchEvent(new CustomEvent("open-checkout", { detail: { source: testId } }));
        }}
        whileHover={{ y: -2 }}
        whileTap={{ scale: 0.97 }}
        transition={{ type: "spring", stiffness: 400, damping: 22 }}
        className={`group inline-flex cursor-pointer items-center justify-center gap-2.5 rounded-full px-7 py-4 font-sans text-[0.78rem] font-bold uppercase tracking-[0.14em] shadow-xl transition-colors duration-300 sm:text-sm ${styles[variant]} ${className}`}
    >
        <span>{children}</span>
        {arrow && (
            <ArrowRight className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-1" />
        )}
    </motion.a>
);
